import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-start-a-community-page',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: './start-a-community-page.component.html',
  styleUrl: './start-a-community-page.component.scss'
})
export class StartACommunityPageComponent {
  launchCapabilities = [
    { icon: 'badge', title: 'Memberships', description: 'Set up member types, dues, and renewals' },
    { icon: 'event', title: 'Events', description: 'Run meetups, dinners, webinars, and conferences' },
    { icon: 'people', title: 'Directories', description: 'Help members find the right peers and connections' },
    { icon: 'campaign', title: 'Communication', description: 'Keep your community informed and engaged' },
    { icon: 'payments', title: 'Payments', description: 'Manage membership and event payments in one place' },
    { icon: 'account_tree', title: 'Growth', description: 'Support chapters, cities, and expansion over time' }
  ];

  launchSteps = [
    'Define your mission',
    'Invite your founding members',
    'Set up memberships, events, and your directory',
    'Launch your first gathering',
    'Grow with consistency'
  ];

  exampleCommunities = [
    'Physician entrepreneur communities',
    'Medical and surgical societies',
    'Founder networks',
    'Investor groups',
    'Local professional associations',
    'Homeowners associations',
    'Trusts'
  ];
}
